
export class Countries {
    static countries = [
      {
        countryId: 1,
        name: 'USA',
        id: 1,
      },
      {
        countryId: 2,
        name: 'CANADA',
        id: 2,
      },
      {
        countryId: 3,
        name: 'South Africa',
        id: 3,
      },
      {
        countryId: 4,
        name: 'Namibia',
        id: 4,
      },
      {
        countryId: 5,
        name: 'New Zealand',
        id: 5,
      },
    ];
  }
  